import { type CreateFacturaModel, type DireccionModel, type FacturaConfigModel, type LiquidacionFacturaModel } from '@api/api';

export class CreateFactura implements CreateFacturaModel {
  CodigoBorrador: string = '';
  FechaEmision: Date = new Date();
  IbanEmisor: string = '';
  NombreEmisor: string = '';
  NifEmisor: string = '';
  DireccionEmisor: DireccionModel = {
    CodigoPostal: null,
    Provincia: null,
    Municipio: null,
    TipoVia: null,
    NombreVia: null,
    Numero: null,
    Escalera: null,
    Piso: null,
    Puerta: null  
  };
  Notas: string | null = null;
  Liquidaciones: LiquidacionFacturaModel[] = [];
  RappelsMensuales: string[] = [];
  IrpfEmpresa: number = 0;
  RutaTemporalFacturaPropia: string | null = null;
  CodigoGestionadoPorColaborador: boolean = false;

  constructor(data?: Partial<CreateFactura>) {
    Object.assign(this, data);
  }

  public createFromConfigFactura(config: FacturaConfigModel): CreateFactura{
    Object.assign(this, config);
    this.CodigoBorrador = config.CodigoFactura;
    return this;
  }

}